import getDefaultParam from '../../../../utils/getDefaultParam.js';

export const getPopoutUrl = (patientId, planSer, fraction, groupIndex, showAll = 0) =>
  // eslint-disable-next-line max-len
  `./weekly-check/${getDefaultParam('organization')}/image/${patientId}/${planSer}/${fraction}/${groupIndex}?showAll=${showAll ? 1 : 0}`;

export const getBlankPopoutUrl = patientId =>
  `./weekly-check/${getDefaultParam('organization')}/image/${patientId}/blank`;

export const DICOM_POPOUT_TARGET = 'dicom-popout';